import 'whatwg-fetch';

export default class HttpRequestor {
  constructor({ suppressErrors = false } = {}) {
    this.nextCsrfToken = null;
    this.suppressErrors = suppressErrors;
  }

  call(url, method, body = {}) {
    let args = {
      method: method,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=utf-8',
        Accept: 'application/json',
      },
      body: body,
      credentials: 'same-origin',
    };

    if (~['POST', 'PATCH', 'PUT', 'DELETE'].indexOf(method)) {
      const token = this.csrfToken();
      args.body['authenticity_token'] = token;
      args.headers['X-CSRF-Token'] = token;
      args.body = JSON.stringify(args.body);
    }

    if (~['GET', 'HEAD'].indexOf(method)) {
      delete args.body;
    }

    return fetch(url, args).then(this.handleErrors).then(this.handleResponse);
  }

  handleErrors = (response) => {
    if (this.suppressErrors) {
      return false;
    }
    if (!response.ok) {
      return response.json().then((data) => {
        if (data['redirect_url']) {
          logger.warn('Response returned redirect');
          location.assign(data['redirect_url']);
        }
        return Promise.reject(data);
      });
    }
    return response;
  };

  handleResponse(response) {
    if (response.status == 204) {
      return null;
    }

    try {
      return response.json();
    } catch (e) {
      return response;
    }
  }

  csrfToken() {
    const csrf_element = document.querySelector('meta[name=csrf-token]');
    const token = this.nextCsrfToken || (csrf_element && csrf_element.getAttribute('content'));
    return token;
  }
}
